package com.gsb.vyapar.bhagya.datasource.mqtt

import com.gsb.vyapar.bhagya.domain.Message
import com.gsb.vyapar.bhagya.domain.toMessage
import com.gsb.vyapar.bhagya.util.gvbLog
import kotlinx.atomicfu.AtomicBoolean
import kotlinx.atomicfu.atomic

object MQTTManager {

    var mqttCallback: (MQTTCallback) -> Unit = {}
    val messages: MutableList<Message> = mutableListOf()
    var connected: AtomicBoolean = atomic(false)

    fun onMQTTCallback(callback: (MQTTCallback) -> Unit) {
        mqttCallback = callback
    }

    fun createMqttClient() {
        mqttCallback(MQTTCallback.CreateMqttClient {

        })
    }

    fun connect() {
        messages.clear()
        if (!connected.value) {
            mqttCallback(MQTTCallback.Connect {

            })
        }
    }

    fun disconnect() {
        messages.clear()
        if (connected.value) {
            mqttCallback(MQTTCallback.Disconnect {

            })
        }
    }

    fun subscribe(topic: String) {
        mqttCallback(MQTTCallback.Subscribe(topic) {

        })
    }

    fun unsubscribe(topic: String) {
        mqttCallback(MQTTCallback.UnSubscribe(topic) {

        })
    }

    fun publish(topic: String, message: String) {
        mqttCallback(MQTTCallback.Publish(topic, message) {

        })
    }

    fun onTriggerMQTTEvent(event: MQTTEvents) {
        when (event) {
            MQTTEvents.OnConnected -> {
                gvbLog("MQTT OnConnected")
                connected.value = true
            }
            is MQTTEvents.OnDisconnected -> {
                gvbLog("MQTT OnDisconnected ${event.error}")
                connected.value = false
            }
            is MQTTEvents.OnMessageReceived -> {
                gvbLog("MQTT OnMessageReceived ${event.topic} -> ${event.message}")
                try {
                    messages.add(event.message.toMessage())
                } catch (e: Exception) {
                    gvbLog(e.message ?: "Unknown Error")
                }
            }
        }
    }
}